<div class="dialog-header">
  <h2 mat-dialog-title>{{ 'quotaStatusDialog.title' | translate }}</h2>
  <button mat-icon-button (click)="close()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="app-info">
    <p><strong>{{ 'quotaStatusDialog.meatType' | translate }}:</strong> {{ getMeatTypeName(data.quota.meatType) }}</p>
  </div>

  <form class="form-content">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'quotaStatusDialog.pin' | translate }}</mat-label>
      <input matInput [ngModel]="personIdnp" name="personIdnp"
             inputmode="numeric" maxlength="14"
             (input)="onNumericInput($event, 'personIdnp')"
             (keydown)="onKeyDown($event)">
    </mat-form-field>
    @if (fieldErrors()['personIdnp']) {
      <div class="field-error">{{ fieldErrors()['personIdnp'] }}</div>
    }

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'quotaStatusDialog.organizationInn' | translate }}</mat-label>
      <input matInput [ngModel]="organizationInn" name="organizationInn"
             inputmode="numeric" maxlength="14"
             (input)="onNumericInput($event, 'organizationInn')"
             (keydown)="onKeyDown($event)">
    </mat-form-field>
    @if (fieldErrors()['organizationInn']) {
      <div class="field-error">{{ fieldErrors()['organizationInn'] }}</div>
    }

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'quotaStatusDialog.status' | translate }}</mat-label>
      <mat-select [(ngModel)]="status" name="status">
        <mat-option value="ACTIVE">{{ 'quotaStatusDialog.statuses.active' | translate }}</mat-option>
        <mat-option value="USED">{{ 'quotaStatusDialog.statuses.used' | translate }}</mat-option>
        <mat-option value="EXPIRED">{{ 'quotaStatusDialog.statuses.expired' | translate }}</mat-option>
        <mat-option value="COMPLETED">{{ 'quotaStatusDialog.statuses.completed' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'quotaStatusDialog.adminComment' | translate }}</mat-label>
      <textarea matInput [(ngModel)]="adminComment" name="adminComment" rows="3"></textarea>
    </mat-form-field>
  </form>

  @if (errorMessage()) {
    <div class="error-message">{{ errorMessage() }}</div>
  }
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">{{ 'quotaStatusDialog.cancel' | translate }}</button>
  <button mat-raised-button color="primary"
          (click)="submit()"
          [disabled]="!isFormValid() || loading()">
    @if (loading()) {
      <mat-spinner diameter="20"></mat-spinner>
    } @else {
      {{ 'quotaStatusDialog.signAndSave' | translate }}
    }
  </button>
</mat-dialog-actions>
